import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PatientService } from 'src/app/services/patient.service';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { getPatientQuery } from '../../../models/PatientAccount';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { TraceClassDecorator } from '@sentry/angular';
import { URLS, roles } from '../../../constant/constant';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { UserService } from 'src/app/services/user.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GoogleTranslateService } from 'src/app/services/google-translate.service'; // Import GoogleTranslateService
import { LanguageService } from 'src/app/services/language.service'; // Import LanguageService

class consultations {
  consultation_type?: {
    consultation_image?: string;
    consultation_name: string;
  };
  consultation_name?: string;
  amount?: string;
  consultation_type_id?: number;
}

class commonissue {
  id: number;
  title: string;
  health_issue_image: string;
  consultation_type: consultations;
}
class appointments {
  doctorPhoto: string;
  doctorname: string;
  appointmentdate: string;
  zoomlink: string;
}

@Component({
  selector: 'app-patientworkflow',
  templateUrl: './patientworkflow.component.html',
  styleUrls: [
    '../../../../assets/css/custom-egd.css',
    './patientworkflow.component.css'
  ]
})
@TraceClassDecorator()
export class PatientworkflowComponent implements OnInit, OnDestroy {
  dietPrice: string[] = [];
  phonenumberlist: string[] = [];
  phoneNumber: string;
  freeDietPrice: string;
  showDiet = false;
  show = false;
  display = true;
  slug: string= "";
  isuserregnumber: boolean = false;
  is_uk_country: boolean = false;
  actualuserregnumber: string = '';
  commonissues: commonissue[] = [];
  consultationList: consultations[] = [];
  is_primary_provider: boolean = false;
  messageList: any[] = [];
  count = 0;
  isIndia: boolean = false;
  carouselItemsIndia = [
    {
      image:
        './assets/images/dashboard/patient/membership_plan_banner_dashboard.png',
      alt: 'Banner 1',
      click: this.slug + '/patient/packages'
    },
    {
      image:
        './assets/images/dashboard/patient/Thursday_offer_banner_dashboard.png',
      alt: 'Banner 2',
      click: this.slug + '/patient/consultdoctor'
    },
    {
      image: './assets/images/dashboard/patient/DietBanner.png',
      alt: 'Banner 3',
      click: this.slug + '/patient/nutrition-and-health'
    },
    {
      image:
        './assets/images/dashboard/patient/Health care package banner_ind.png',
      alt: 'Banner 4',
      click: this.slug + '/patient/packages'
    }
  ];

  carouselItemsUSA = [
    {
      image:
        './assets/images/dashboard/patient/Health care package banner_White_bg.png',
      alt: 'Banner 3',
      click: this.slug + '/patient/packages'
    },
    {
      image: './assets/images/dashboard/patient/DietBanner.png',
      alt: 'Banner 2',
      click: this.slug + '/patient/nutrition-and-health'
    }
  ];

  languageOptions: { code: string, name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'fr', name: 'French' },
    { code: 'ar', name: 'Arabic'},
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'de', name: 'German' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'te', name: 'Telugu' },
    { code: 'ta', name: 'Tamil' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'kn', name: 'Kannada' },
    { code: 'or', name: 'Oriya' },
    { code: 'ne', name: 'Nepali' }
];


  selectedLanguage: string = 'en'; // Default language

  navigationSubscription: Subscription;

  constructor(
    private readonly patientService: PatientService,
    private readonly messageService: MessagecenterService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly utilitiesService: UtilitiesService,
    private readonly userservice: UserService,
    private readonly router: Router,
    private readonly translateService: GoogleTranslateService,
    private readonly providerstateService: ProviderStateService,
    private readonly googleTranslateService: GoogleTranslateService, // Inject GoogleTranslateService
    private readonly languageService: LanguageService // Inject LanguageService
  ) {
    
  }

  query: getPatientQuery = {
    date: new Date().toISOString()
  };

  userName: string;
  appointmentsList: appointments[] = [];
  appointment = new appointments();
  isSectionVisible: boolean = false;
  isUK = false;

  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    if(URLS.IS_UK)
    {
      this.is_uk_country = true;
    }
    this.breadcrumbService.setItems([{ label: 'Dashboard' }]);
    this.isUK = !!URLS.IS_UK
    await this.patientService
    .getConsultationAndCommonHealthIssueData()
    .toPromise()
    .then((result) => {
      if (result.success) {
        this.consultationList = result.data.consultations;
        this.commonissues = result.data.common_health_issues;
        this.userName = result.data.first_name;
        // this.dietPrice = result.data.diet_plans;
        // this.dietPrice[0] = result.data.diet_plans[0].renderedAmount; //3 weeek pricing
        // this.dietPrice[1] = result.data.diet_plans[1].renderedAmount; // 3 month pricing
        this.phoneNumber = result.data.phone;
        this.phonenumberlist = result.data.phoneNumberList.map(phoneNumberObj => phoneNumberObj.phoneNumber as string);
        this.freeDietPrice = result.data.free_diet_plan_banner_price;
        if (result.data.country_id == 101) {
          this.isIndia = true;
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
  await this.messageService
    .getMessagesForDashborad(roles.patient)
    .toPromise()
    .then((result) => {
      if (result.success) {
        this.messageList = result.data.message_list.rows;
        this.count = result.data.message_list.count;
      }
    })
    .catch((error) => {
      console.log(error);
    });
  await this.patientService
    .getPatientAppointments(this.query)
    .toPromise()
    .then((res) => {
      if (res.success) {
        for (let i = 0; i < res.data.length; i++) {
          this.appointment = new appointments();
          this.appointment.appointmentdate = res.data[i].consultation_date;
          this.appointment.doctorname = res.data[i].p_consultation_appointment
            .map((d) => {
              return d.egd_users.first_name + ' ' + d.egd_users.last_name;
            })
            .join(' ');
          this.appointment.doctorPhoto =
            res.data[i].p_consultation_appointment[0].egd_users.avatar_url;
          this.appointment.zoomlink =
            res.data[i].zoom_meetings != null
              ? res.data[i].zoom_meetings.join_url
              : '';
          this.appointmentsList.push(this.appointment);
        }
        if (!(this.appointmentsList.length == 0)) {
          this.isSectionVisible;
        }
        const now = new Date();

        this.appointmentsList = this.appointmentsList.filter((v) => {
          const appointmentDate = new Date(v.appointmentdate);
          const fifteenMinutesAfterStart = new Date(
            appointmentDate.getTime() + 15 * 60000
          );
          return fifteenMinutesAfterStart > now;
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });


    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async () => {
        await this.initPageData();
      });

 
    this.initializeLanguage();
  }

  async initPageData() {
    await this.patientService
    .getConsultationAndCommonHealthIssueData()
    .toPromise()
    .then((result) => {
      if (result.success) {
        this.consultationList = result.data.consultations;
        this.commonissues = result.data.common_health_issues;
        this.userName = result.data.first_name;
        this.dietPrice = result.data.diet_plans;
        this.dietPrice[0] = result.data.diet_plans[0].renderedAmount; //3 weeek pricing
        this.dietPrice[1] = result.data.diet_plans[1].renderedAmount; // 3 month pricing
        this.phoneNumber = result.data.phone;
        this.phonenumberlist = result.data.phoneNumberList.map(phoneNumberObj => phoneNumberObj.phoneNumber as string);
        this.freeDietPrice = result.data.free_diet_plan_banner_price;
        if (result.data.country_id == 101) {
          this.isIndia = true;
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
  await this.messageService
    .getMessagesForDashborad(roles.patient)
    .toPromise()
    .then((result) => {
      if (result.success) {
        this.messageList = result.data.message_list.rows;
        this.count = result.data.message_list.count;
      }
    })
    .catch((error) => {
      console.log(error);
    });
  await this.patientService
    .getPatientAppointments(this.query)
    .toPromise()
    .then((res) => {
      if (res.success) {
        for (let i = 0; i < res.data.length; i++) {
          this.appointment = new appointments();
          this.appointment.appointmentdate = res.data[i].consultation_date;
          this.appointment.doctorname = res.data[i].p_consultation_appointment
            .map((d) => {
              return d.egd_users.first_name + ' ' + d.egd_users.last_name;
            })
            .join(' ');
          this.appointment.doctorPhoto =
            res.data[i].p_consultation_appointment[0].egd_users.avatar_url;
          this.appointment.zoomlink =
            res.data[i].zoom_meetings != null
              ? res.data[i].zoom_meetings.join_url
              : '';
          this.appointmentsList.push(this.appointment);
        }
        if (!(this.appointmentsList.length == 0)) {
          this.isSectionVisible;
        }
        const now = new Date();

        this.appointmentsList = this.appointmentsList.filter((v) => {
          const appointmentDate = new Date(v.appointmentdate);
          const fifteenMinutesAfterStart = new Date(
            appointmentDate.getTime() + 15 * 60000
          );
          return fifteenMinutesAfterStart > now;
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  async openLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }

  RouterNavigation(path: string) {
    this.router.navigate(["/" +  this.slug + path]);
  }

  async getRegistrationNumber() {
    await this.userservice
      .GetUserData(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.isuserregnumber = result.data.user_reg_numbers != null;
          this.actualuserregnumber =
            result.data.user_reg_numbers?.reg_number || '';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async translatePage(event: Event) {
    const selectedLangCode = (event.target as HTMLSelectElement).value;
    this.selectedLanguage = selectedLangCode; // Update selected language
    localStorage.setItem('selectedLanguageClient', selectedLangCode); // Save to localStorage
    this.googleTranslateService.setGoogleTranslateLanguage(selectedLangCode);
    this.languageService.setLanguage(selectedLangCode);

    // Update notranslate class based on the selected language
    if (selectedLangCode === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  initializeLanguage() {
    const savedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';
    this.selectedLanguage = savedLanguage;
    this.googleTranslateService.setGoogleTranslateLanguage(savedLanguage);

    // Update notranslate class based on the saved language
    if (savedLanguage === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
